import vueSlideoutPanelService from '@/components/vue-slideout-panel/service'

const Panel = {
  install (Vue, options) {
    Vue.prototype.$panel = function (component, props, width = '800px', position = 'right') {
      const options = {
        openOn: position,
        component,
        props,
        // disableBgClick: true,
        cssClass: 'slider-default',
        width: width
      }

      const handle = vueSlideoutPanelService.showPanel(options)
      return handle.promise
    }
  }
}

export default Panel



// WEBPACK FOOTER //
// ./src/plugins/panel.js